const MeterStatusType = {
    1: '지불',
    2: '지불메뉴',
    5: '빈차',
    20: '주행',
    30: '할증',
    31: '심야 할증 자동',
    32: '시외 할증 자동',
    33: '시외 할증 수동',
    34: '중복 할증(심야 + 시외 등)',
    35: '복합 할증 자동',
    36: '복합 할증 수동',
    37: '거리 할증 자동',
    50: '휴무',
    51: '예약',
    61: '교대',
    62: '시계외',
    91: '출근',
    92: '퇴근',
    98: 'ACC ON',
    99: 'ACC OFF',
}

export default MeterStatusType
